<div class="product-details"
     [class.product-details--collapse]="isProductHidden"
     [ngClass]="{'enlarged-image' : enlargedImage}"
     [@changeProductCollapseState]="productCollapseState">
  <div class="product-details__info"
       [class.product-details__info--has-padding]="hasPadding"
       [ngClass]="{'w-100' : isEnlargedImage}">
    <p class="product-details__name">
      {{cleanedName(product.info?.name)}}
    </p>
    <div class="product-details__description">
      <ng-container *ngIf="truncateDescription else fullDescription">
        <div *ngIf="product.info.description" [innerHTML]="formattedProductDescription" [line-truncation]="truncateLength"></div>
      </ng-container>
      <ng-template #fullDescription>
        <div [innerHTML]="productDescription" *ngIf="isStoneCreek"></div>
        <span class="product-details__description-available-info" *ngIf="chosenVariation && chosenVariation.isLeadTimesEnabled && variationLeadTime.length">{{variationLeadTime}}<br/></span>
        <span class="product-details__description-available-info" *ngIf="chosenVariation && (chosenVariation.isDailyRestrictionEnabled || chosenVariation.isFulfillmentRestrictionEnabled) && availableText.length">{{availableText}}<br/></span>
        <span class="product-details__description-available-info" *ngIf="chosenVariation && chosenVariation.isStartEndDatesEnabled && availableFromUntilText.length">{{availableFromUntilText}}<br/></span>
        <span [innerHTML]="productDescription" *ngIf="!isStoneCreek"></span>
      </ng-template>
    </div>
    <div class="product-details__nutrition" *ngIf="chosenVariation?.nutrition_facts_enabled">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="nutrition-container">
              Nutrition Facts
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>{{getNutritionFacts(chosenVariation.nutrition_facts)}}</p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <p *ngIf="isSoldOut(product)" class="product-details__remainder">
      {{restaurant.enableSoldOutOrders ? 'Sold out today (future orders accepted)': 'Sold out'}}
    </p>
    <p class="product-details__price" [hidden]="hidePrice">
      <ng-container *ngIf="getPriceRange(product).length === 2; else productWithOnePrice">
         <span>
           {{currencySign}}{{getFormattedPrice(getPriceRange(product)[0])}} &ndash; {{currencySign}}{{getFormattedPrice(getPriceRange(product)[1])}}
         </span>
      </ng-container>

      <ng-template #productWithOnePrice>
              <span [class.no-opacity]="getFormattedPrice(getPriceRange(product)[0]) ==='0.00'">
                {{currencySign}}{{getFormattedPrice(getPriceWithModifiers(product))}}
              </span>
      </ng-template>
    </p>
    <!-- <p class="product-details__price">
      <ng-container *ngIf="isDisplayKyooFee(restaurant)">
        <span [class.no-opacity]="getFormattedFee(restaurant.kyooFee) ==='0.00'">
          + {{currencySign}}{{getFormattedFee(restaurant.kyooFee)}} service fee
        </span>
      </ng-container>
    </p> -->
  </div>
  <ng-container *ngIf="product.info.imageUrl; else defaultImage">
    <ion-thumbnail class="product-details__image-wrapper" *ngIf="product.info.imageUrl"
      [class.product-details__image-wrapper--has-all-border-radius]="hasAllBorderRadius"
      [class.product-details__image-wrapper--has-all-border-radius-enlarged]="isEnlargedImage">
      <div class="product-details__image"
           [defaultImage]="''"
           [lazyLoad]="imageUrl">
      </div>
      <ion-button *ngIf="!isEnlargedImage && enableFavorite" class="heart-button" (click)="toggleHeart($event)">
        <svg class="heart-icon">
          <image [attr.xlink:href]="'assets/icon/' + (isFavorite ? 'heart-full.svg' : 'heart-empty.svg')" width="22" height="22"></image>
        </svg>
      </ion-button>
    </ion-thumbnail>
  </ng-container>
  <ng-template #defaultImage>
    <ion-thumbnail class="product-details__image-wrapper"
          [class.product-details__image-wrapper--has-all-border-radius-enlarged]="enlargedImage" *ngIf="enableFavorite">
      <div class="product-details__image product-details__image--default">
      </div>
      <ion-button *ngIf="!isEnlargedImage && enableFavorite" class="heart-button" (click)="toggleHeart($event)">
        <svg class="heart-icon">
          <image [attr.xlink:href]="'assets/icon/' + (isFavorite ? 'heart-full.svg' : 'heart-empty.svg')" width="22" height="22"></image>
        </svg>
      </ion-button>
    </ion-thumbnail>
  </ng-template>
</div>
